import {useEffect, useState} from 'react';
import {Button, Card, Dropdown, OverlayTrigger, Table, Tooltip} from 'react-bootstrap';
import {Link, useNavigate} from 'react-router-dom';
import Authenticator from '../authenticator';
import Loading from '../components/loading';
import SuccessMessage from '../components/successMessage';
import ErrorMessage from '../components/errorMessage';
import api from '../api/api';

export default function DosageEstudyList() {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [registeredDosageStudies, setRegisteredDosageStudies] = useState([]);

  useEffect(() => {
    getAllRegisteredDosageStudies();
  }, []);

  function getAllRegisteredDosageStudies() {
    setLoading(true);
    api
      .get('/dosage-study', {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        setRegisteredDosageStudies(returnFromApi.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error('ops! ocorreu um erro' + error);
      });
  }

  function openDosageStudy(dosageStudy) {
    navigate(`/dosage-study/form?id=${dosageStudy.id}`);
  }

  function addNewDosageStudy() {
    navigate('/dosage-study/form');
  }

  function deleteDosageStudy(dosageStudy) {
    setLoading(true);
    api
      .delete(`/dosage-study/${dosageStudy.id}`, {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        getAllRegisteredDosageStudies();
        setShowSuccessMessage(true);
        setSuccessMessage(returnFromApi.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error('ops! ocorreu um erro' + error);
      });
  }

  return (
    <Card className="bg-transparent-50 overflow-hidden">
      <Authenticator />
      {showSuccessMessage && <SuccessMessage message={successMessage} setShow={setShowSuccessMessage} />}
      {showErrorMessage && <ErrorMessage message={errorMessage} setShow={setShowErrorMessage} />}
      <Loading isToHidden={isLoading == false} />

      <Card.Header className="position-relative">
        <div className="row flex-between-center">
          <div className="col col-lg-8">
            <h5 className="mb-0 texto-negrito">Estudos de Dosagem Cadastrados</h5>
          </div>
          <div className="col-12 col-sm-auto ms-auto">
            <Button variant="falcon-primary" className="me-2 mb-1" onClick={() => addNewDosageStudy()}>
              Cadastrar Novo Estudo
            </Button>
          </div>
        </div>

        <Loading isToHidden={isLoading == false} />

        <div hidden={isLoading}>
          <div className="text-center" hidden={registeredDosageStudies.length > 0}>
            <p className="lead mt-4 text-800 font-sans-serif fw-semi-bold w-md-75 w-xl-100 mx-auto">
              Nenhum estudo cadastrado ainda.
            </p>
          </div>
        </div>
      </Card.Header>
      <Card.Body className="p-0" hidden={registeredDosageStudies.length == 0}>
        <Table responsive className={`form-container ${isLoading ? 'loading' : ''}`}>
          <thead>
            <tr>
              <th scope="col">Nome</th>
              <th scope="col">Código</th>
              <th scope="col">Data</th>
              <th scope="col">Observações</th>
              <th className="text-end" scope="col"></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {registeredDosageStudies.map((dosageStudy) => {
              return (
                <tr key={dosageStudy.id}>
                  <td>{dosageStudy.name}</td>
                  <td>{dosageStudy.code}</td>
                  <td>{dosageStudy.formattedCreatedDate}</td>
                  <td>
                    <OverlayTrigger placement="top" overlay={<Tooltip>{dosageStudy.observations}</Tooltip>}>
                      <span
                        style={{
                          maxWidth: '300px',
                          display: 'inline-block',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis'
                        }}
                      >
                        {dosageStudy.observations || '-'}
                      </span>
                    </OverlayTrigger>
                  </td>
                  <td className="text-end">
                    <Dropdown className="d-inline-block ms-2">
                      <Dropdown.Toggle variant="falcon-default">Ações</Dropdown.Toggle>
                      <Dropdown.Menu className="py-2">
                        <Dropdown.Item as={Link} onClick={() => openDosageStudy(dosageStudy)}>
                          Visualizar
                        </Dropdown.Item>
                        <Dropdown.Divider as="div" />
                        <Dropdown.Item as={Link} onClick={() => deleteDosageStudy(dosageStudy)} className="text-danger">
                          Excluir
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}
